module.exports = require("solc");


//////////////////
// WEBPACK FOOTER
// external "solc"
// module id = 470
// module chunks = 0